import React from 'react';
import './Button.scss'

const Button = (props) => (
    <button className="btn btnLarge btnPrimary btnBlock" onClick={props.action} data-testid="button">{props.text}</button>
);

export default Button;